import * as React from "react";
import { InfoCard } from "uxp/components";

interface ICardProps {
    icon: string;
    title: string;
    subtitle: string;
    onClick: () => void;
    selected?: boolean;
}
// Shared card used by every category — a bordered rounded surface wrapping the
// existing InfoCard visual language (icon circle + title + subtitle). Rendered
// in a 3-per-row grid (list mode) and 1-per-row in the rail (master-detail).
export const Card: React.FunctionComponent<ICardProps> = ({ icon, title, subtitle, onClick, selected }) => (
    <div
        className={'uxp_wd-dsp__card' + (selected ? ' uxp_wd-dsp__card--selected' : '')}
        onClick={onClick}
    >
        <InfoCard
            data={{ title, subtitle, icon }}
            fields={{ image: 'icon', title: 'title', subtitle: 'subtitle' }}
        />
    </div>
);
